import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from './assets/lt.png';
import _imports_1 from './assets/rb.png';
import _imports_2 from '@/assets/wx.png';
const _withScopeId = n => (_pushScopeId("data-v-07d1fba2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tab flex rounded-lg"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "text-center"
};
const _hoisted_5 = {
  class: "text-xs mt-1"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "mt-5 px-5 box"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-base font-bold my-5"
}, "选择套餐", -1));
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  key: 0,
  class: "tj"
};
const _hoisted_11 = {
  class: "title my-5 text-[15px] font-bold"
};
const _hoisted_12 = {
  class: "unit"
};
const _hoisted_13 = {
  class: "font-sans mb-5 num text-3xl font-bold"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text-sm"
}, "¥", -1));
const _hoisted_15 = ["data-price"];
const _hoisted_16 = {
  key: 1
};
const _hoisted_17 = {
  class: "day mb-5 text-xs mt-2"
};
const _hoisted_18 = {
  class: "p-1 bg-orange-300/20 text-orange-500 rounded"
};
const _hoisted_19 = {
  key: 0
};
const _hoisted_20 = {
  key: 1
};
const _hoisted_21 = {
  class: "text-xs mt-2 text-left text-orange-800/80 flex items-center"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text-red"
}, "*", -1));
const _hoisted_23 = {
  class: "mt-5 flex justify-between flex-col md:flex-row"
};
const _hoisted_24 = {
  class: "flex-1"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-base font-bold mb-3"
}, "支付订单", -1));
const _hoisted_26 = {
  class: "relative border"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "absolute",
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_28 = ["src"];
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "absolute right-0 bottom-0",
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_30 = {
  class: "flex flex-col justify-around"
};
const _hoisted_31 = {
  class: "price font-sans font-bold"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "mb-2"
}, "应付金额：", -1));
const _hoisted_33 = {
  class: "font-sans mb-2 num text-3xl font-bold text-orange-500"
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text-xs text-gray-500"
}, "¥", -1));
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-xs flex items-center"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "w-5 mr-2",
  src: _imports_2,
  alt: ""
}), /*#__PURE__*/_createTextVNode("使用微信扫码支付 ")], -1));
const _hoisted_36 = {
  class: "timer text-left mt-2"
};
const _hoisted_37 = {
  class: "text-left mt-2 flex items-center"
};
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ml-2"
}, "开通会员代表您接受", -1));
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "underline underline-offset-1",
  href: "https://note.youdao.com/ynoteshare/index.html?id=c8383bf109386c74017f49081a59803f&type=note&_time=1684155990130"
}, "《订阅会员协议》", -1));
const _hoisted_40 = {
  class: "flex-1 md:pl-5"
};
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-base font-bold mb-8"
}, "会员权益", -1));
const _hoisted_42 = {
  class: "p-3 flex text-center justify-around"
};
const _hoisted_43 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QuestionFilled = _resolveComponent("QuestionFilled");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_popover = _resolveComponent("el-popover");
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_ai_dialog = _resolveComponent("ai-dialog");
  const _component_coupon_dialog = _resolveComponent("coupon-dialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_ai_dialog, _mergeProps({
    class: "relative mt-0 box-border rounded-none sm:rounded-md w-screen h-full overflow-auto sm:mt-[7vh] sm:h-auto sm:w-2/3 md:w-11/12 lg:w-2/3 vip-dialog pb-10"
  }, {
    ..._ctx.$attrs
  }, {
    onOpened: _ctx.opened,
    "before-close": _ctx.closed
  }), {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vipTypeObj, item => {
      return _openBlock(), _createElementBlock("div", {
        class: "cursor-pointer relative tab-item w-1/2 text-base",
        key: item.value,
        onClick: $event => _ctx.vipType = item.value
      }, [_createElementVNode("div", {
        onClick: $event => _ctx.vipType = item.value,
        class: "cursor-pointer absolute flex items-center justify-center h-full w-full"
      }, [_createElementVNode("div", _hoisted_4, [_createTextVNode(_toDisplayString(item.name) + " ", 1), _createElementVNode("div", _hoisted_5, _toDisplayString(item.desc), 1)])], 8, _hoisted_3), _withDirectives(_createElementVNode("img", {
        class: "h-full",
        src: require(item.value === 0 ? './left.png' : './right.png'),
        alt: ""
      }, null, 8, _hoisted_6), [[_vShow, _ctx.vipType === item.value]])], 8, _hoisted_2);
    }), 128))]), _createElementVNode("div", _hoisted_7, [_hoisted_8, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vipTypeObj, type => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "flex flex-wrap md:justify-center",
        key: type.value
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(type.list, item => {
        return _openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "p-2 cursor-pointer vip-item w-1/2 md:w-1/4 mb-2",
          onClick: $event => _ctx.chooseVip(type.value, item)
        }, [_createElementVNode("div", {
          class: _normalizeClass(["relative bg-white border-2 box-border rounded-md text-center", {
            'active border-orange-500 shadow-md text-orange-500': item.id === type.active.id
          }])
        }, [item.num === 12 ? (_openBlock(), _createElementBlock("div", _hoisted_10, "推荐套餐")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_11, [_createElementVNode("span", _hoisted_12, _toDisplayString(item.num) + "个月会员", 1)]), _createElementVNode("div", _hoisted_13, [_hoisted_14, item.num >= 12 ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          "data-price": item.price,
          ref_for: true,
          ref: `price${item.banben}`
        }, _toDisplayString(_ctx.useCoupon ? item.price - 100 : item.price), 9, _hoisted_15)) : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(item.price), 1))]), _createElementVNode("div", _hoisted_17, [_createElementVNode("span", _hoisted_18, [item.num >= 12 ? (_openBlock(), _createElementBlock("span", _hoisted_19, "每天仅¥" + _toDisplayString(((_ctx.useCoupon ? item.price - 100 : item.price) / (item.num * 30)).toFixed(2)) + "元", 1)) : (_openBlock(), _createElementBlock("span", _hoisted_20, "每天仅¥" + _toDisplayString((item.price / (item.num * 30)).toFixed(2)) + "元", 1))])])], 2)], 8, _hoisted_9);
      }), 128))])), [[_vShow, _ctx.vipType === type.value]]);
    }), 128)), _createElementVNode("div", _hoisted_21, [_hoisted_22, _createTextVNode(_toDisplayString(_ctx.vipTypeObj[_ctx.VIP_TYPE[_ctx.vipType]].tip) + " ", 1), _createVNode(_component_el_popover, {
      width: 200,
      trigger: "click",
      content: "无限次绘画仅限在购买配套套餐期内使用，配套套餐时间到期，绘画额度清零。"
    }, {
      reference: _withCtx(() => [_withDirectives(_createVNode(_component_el_icon, {
        class: "ml-2 text-sm cursor-pointer"
      }, {
        default: _withCtx(() => [_createVNode(_component_QuestionFilled)]),
        _: 1
      }, 512), [[_vShow, _ctx.vipType === 1]])]),
      _: 1
    })]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_hoisted_25, _createElementVNode("div", {
      class: _normalizeClass(["flex md:border-r md:pr-5 justify-between", {
        'opacity-0': !_ctx.agreement
      }])
    }, [_createElementVNode("div", _hoisted_26, [_hoisted_27, _createElementVNode("img", {
      class: "w-36",
      src: _ctx.qrcodeImg
    }, null, 8, _hoisted_28), _hoisted_29]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_hoisted_32, _createElementVNode("div", _hoisted_33, [_hoisted_34, _createTextVNode(_toDisplayString(_ctx.payPrice), 1)])]), _hoisted_35, _createElementVNode("div", _hoisted_36, " 支付剩余时间：" + _toDisplayString(_ctx.toTime(_ctx.payTimeOut)), 1)])], 2), _createElementVNode("div", _hoisted_37, [_createVNode(_component_el_checkbox, {
      modelValue: _ctx.agreement,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.agreement = $event)
    }, null, 8, ["modelValue"]), _hoisted_38, _hoisted_39])]), _createElementVNode("div", _hoisted_40, [_hoisted_41, _createElementVNode("div", _hoisted_42, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vipTypeObj[_ctx.VIP_TYPE[_ctx.vipType]].vipItem, item => {
      return _openBlock(), _createElementBlock("div", {
        class: "vip",
        key: item.icon
      }, [_createElementVNode("img", {
        src: require(`./assets/${item.icon}.png`),
        alt: ""
      }, null, 8, _hoisted_43), _createElementVNode("div", null, _toDisplayString(item.name), 1)]);
    }), 128))])])])])]),
    _: 1
  }, 16, ["onOpened", "before-close"]), _createVNode(_component_coupon_dialog, {
    modelValue: _ctx.showCouponDialog,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.showCouponDialog = $event),
    onUseCoupon: _ctx.selectedCoupon,
    onClose: _cache[2] || (_cache[2] = $event => _ctx.showCouponDialog = false)
  }, null, 8, ["modelValue", "onUseCoupon"])], 64);
}